export enum APIPath {
  example = '/v1/example',
  //for user authentication
  login = '/merchant-service/OAuth/token',
  resetPassword = '/merchant-service/user/reset-password',
  verifyToken = '/merchant-service/user/reset-password-token',
  updatePassword = '/merchant-service/user/update-reset-password',
  myMerchants = '/merchant-service/merchant/my-merchants',
  staffMerchants = '/backend/api/v1/auth/store/staff/merchants',
  findRegisterToken = '/merchant-service/merchant/find-register-token',
  registerNewAccount = '/merchant-service/merchant/register-user',
  staffLogin = '/backend/api/v1/auth/store/staff/login',
  staffPermission = '/backend/api/v1/auth/store/staff/permissions',
  merchantPermission = '/backend/api/v1/auth/merchant/permissions',
  refreshToken = '/merchant-service/OAuth/token',

  //banner
  bannerList = '/bs-service/advertise/ads',
  createBanner = '/bs-service/advertise/create-ad',
  updateBanner = '/bs-service/advertise/update-ad',
  deleteBanner = '/bs-service/advertise/delete-ad',
  getBannerByID = '/bs-service/advertise/find-ad',

  //advertise
  advertiseList = '/backend/api/v1/ads',
  createAdvertise = '/backend/api/v1/ads',
  updateAdvertise = '/backend/api/v1/ads/:id',
  deleteAdvertise = '/backend/api/v1/ads/:id',
  getAdvertiseByID = '/backend/api/v1/ads/:id',

  //upload
  upload = '/cdn/upload',

  //coupon
  couponList = '/order-service/coupon/campaigns',
  createCoupon = '/order-service/coupon/create-campaign',
  updateCoupon = '/order-service/coupon/update-campaign',
  getCouponByID = '/order-service/coupon/campaign',

  //merchants
  merchantsList = '/merchant-service/merchant/merchants',
  approveMerchants = '/merchant-service/merchant/approve-merchant',
  rejectMerchants = '/merchant-service/merchant/reject-merchant',
  updateMerchants = '/merchant-service/merchant/update-merchant',
  getMerchantsByID = '/merchant-service/merchant/find-merchant',
  getPointHistory = '/order-service/point-service/get-merchant-points-list',
  getPointRedeem = '/order-service/point-service/get-merchant-redeems-list',
  getPointSummary = '/order-service/point-service/get-merchant-points-summary',
  //merchants
  merchantsDropdown = '/merchant-service/merchant/get-merchants-dropdown',

  //uom
  uomList = '/product-service/uom/uoms',
  createUom = '/product-service/uom/create-uom',
  updateUom = '/product-service/uom/update-uom',
  deleteUom = '/product-service/uom/delete-uom',
  getUomByID = '/product-service/uom/find-uom',

  //manufactuer
  manufacturerList = '/product-service/manufacturer/manufacturers',
  createManufacturer = '/product-service/manufacturer/create-manufacturer',
  updateManufacturer = '/product-service/manufacturer/update-manufacturer',
  deleteManufacturer = '/product-service/manufacturer/delete-manufacturer',
  getManufacturerByID = '/product-service/manufacturer/find-manufacturer',

  //categories
  categoriesList = '/product-service/product-category/product-categories',
  createCategories = '/product-service/product-category/create-product-category',
  updateCategories = '/product-service/product-category/update-product-category',
  deleteCategories = '/product-service/product-category/delete-product-category',
  getCategoriesByID = '/product-service/product-category/find-product-category',

  //product
  productList = '/backend/api/v1/product/products',
  createProduct = '/backend/api/v1/product/create',
  updateProduct = '/backend/api/v1/product/update',
  deleteProduct = '/product-service/product/delete-product',
  getProductByID = '/backend/api/v1/product/product/:id',
  updateProductStatus = '/product-service/product/update-product-status',
  updateProductPrice = '/backend/api/v1/product/update-price',
  getBomByProductID = '/backend/api/v1/bom-product/list',
  updateProductBom = '/backend/api/v1/bom-product/update',
  //import product
  getMasterProduct = '/product-service/product/find-master-products',
  getMerchantMasterProduct = '/product-service/product/find-merchant-master-products',
  importProducts = '/product-service/product/import-products',
  //product requested
  // historiesList = 'product-service/product/get-request-products-update',
  getRequestProduct = '/backend/api/v1/product/get-request-products-update',
  getRequestProducts = '/backend/api/v1/product/get-request-products-list',
  getRequestProductDetail = '/backend/api/v1/product/get-request-products-detail',
  updateRequestProductsStatus = '/backend/api/v1/product/update-request-status',
  //get product for coupon
  getAllProductList = '/api/v1/product/products',

  //import from excel
  checkImportProductsFromFile = '/backend/api/v1/product/import-checking',
  createImportProductsFromFile = '/backend/api/v1/product/import',

  //deliveryOld
  getDeliveryCostOld = '/geo-service/delivery-cost/delivery-costs',
  updateDeliveryCostOld = '/geo-service/delivery-cost/updates',

  //delivery
  getDeliveryCost = '/geo-service/delivery-cost-configs/get-delivery-cost-config',
  updateDeliveryCost = '/geo-service/delivery-cost-configs/save-delivery-cost-config',
  inquryDeleteDeliveryCost = '/geo-service/delivery-cost-configs/delete-delivery-cost-config',

  //order
  getOrderList = '/v1/orders',
  countNewOrder = '/v1/orders/new',
  updateOrderStatus = '/order-service/order/update-product-status',
  createBestTracking = '/geo/best/pdf',
  getOrderByID = '/order-service/order/find-order',
  getOrderLogs = '/order-service/order/OrderLogs',
  getPOSBill = '/backend/api/v1/order/bill/order/:id',
  exportOrder = '/backend/api/v1/report/order/export',
  exportOrderShortly = '/backend/api/v1/report/order/export-shortly',
  updateTerminalStatusAuto = '/order-service/order/auto-update-pos-order-status',
  updateTerminalAddress = '/backend/api/v1/order/update-address',
  updatePaymentType = '/backend/api/v1/order/update-payment-type',

  //dashboard
  paymentDashboard = '/backend/api/v1/order/payment/dashboard',
  paymentStatDashboard = '/backend/api/v1/order/payment/dashboard/stat',
  topSaleDashboard = '/backend/api/v1/order/payment/dashboard/sale',
  supplierDashboard = '/backend/api/v1/order/payment/dashboard/supplier',
  returnDashboard = '/backend/api/v1/order/return-summary',
  terminalProfitDashboard = '/backend/api/v1/report/dashboard/profit-discount',

  //pos
  posMerchantPackage = '/backend/api/v1/merchant/staff/package',
  posGetStaffRoles = '/backend/api/v1/merchant/package/roles',
  posGetStaffList = '/backend/api/v1/merchant/staffs',
  posGetStaffByID = '/backend/api/v1/merchant/staff/:id',
  posCreateStaff = '/backend/api/v1/merchant/staff',
  posUpdateStaff = '/backend/api/v1/merchant/staff/:id',
  posDeleteStaff = '/backend/api/v1/merchant/staff/:id',
  posUpdateStaffStaus = '/backend/api/v1/merchant/staff/status/:id',
  posResetStaffPin = '/backend/api/v1/merchant/staff/pin/:id',
  posMerchantPackageList = '/backend/api/v1/merchant/package',
  posPackageSpec = '/backend/api/v1/merchant/package/spec',
  posPackageSpecByID = '/backend/api/v1/merchant/package/:id',
  posBuyPackage = '/backend/api/v1/merchant/package/buy',
  posRenewPackage = '/backend/api/v1/merchant/package/renew',
  posActivatePackage = '/backend/api/v1/merchant/package/activate/:id',
  posPackageLog = '/backend/api/v1/merchant/package/log/:id',
  checkMerchantPackage = '/backend/api/v1/merchant/package',
  getMerchantConfig = '/backend/api/v1/merchant/config/get',
  setMerchantConfig = '/backend/api/v1/merchant/config/set',
  getMerchantConfigList = '/backend/api/v1/merchant/configs/get',
  setPaymentConfig = '/backend/api/v1/merchant/payment-channel/update',
  getPaymentConfigList = '/backend/api/v1/merchant/payment-channel',

  //pos-mornitoring
  posMornitoringList = '/backend/api/v1/terminal/monitoring',
  posMornitoringDetail = '/backend/api/v1/terminal/monitoring/:id',
  posRegenerate = '/backend/api/v1/terminal/monitoring/serial/:id',

  //manage-user
  getUserList = '/backend/api/v1/merchant/store/staffs',
  getMerchantRoleList = '/backend/api/v1/merchant/store/staff/roles',
  merchantCreateUserStaff = '/backend/api/v1/merchant/store/staff',
  merchantUserByID = '/backend/api/v1/merchant/store/staff/:id',
  merchantUpdateUserStaff = '/backend/api/v1/merchant/store/staff/:id',
  merchantResetStaffPin = '/backend/api/v1/merchant/store/staff/reset-password/:id',
  merchantUpdateUserStaus = '/backend/api/v1/merchant/store/staff/status/:id',
  merchantDeleteUser = '/backend/api/v1/merchant/store/staff/:id',

  //suppliers
  supplierList = '/backend/api/v1/product/supplier/list',
  createSupplier = '/product-service/supplier-service/create-supplier',
  updateSupplier = '/product-service/supplier-service/update-supplier',
  deleteSupplier = '/product-service/supplier-service/delete-supplier',
  getSupplierByID = '/product-service/supplier-service/get-supplier',

  //sale order customer
  customerList = '/backend/api/v1/order/customer-lists',
  createCustomer = '/backend/api/v1/order/customers',
  updatCustomer = '/backend/api/v1/order/customers/:id',
  deleteCustomer = '/product-service/supplier-service/delete-supplier',
  getCustomerByID = '/backend/api/v1/order/customers/:id',
  saleOrderList = '/backend/api/v1/order/customer-sale-lists/:id',

  //purchase
  purchaseList = '/backend/api/v1/product/purchasing/list',
  createPurchase = '/backend/api/v1/order/purchasing/create',
  updatePurchase = '/product-service/purchasing-service/update-purchasing',
  deletePurchase = '/product-service/purchasing-service/delete-purchasing',
  getPurchaseByID = '/backend/api/v1/order/purchasing/:id',
  updatePurchaseStatus = '/product-service/purchasing-service/update-purchasing-status',
  getPurchaseLogs = '/product-service/purchasing-service/get-purchasing-logs',
  countPurchase = '/notify/api/v1/purchasing/count-all-status',
  countPurchaseReceipt = '/notify/api/v1/purchasing/count-receipt-status',

  //grn
  grnList = '/product-service/grn-service/get-grn-list',
  createGrn = '/product-service/grn-service/create-grn',
  updateGrn = '/product-service/grn-service/update-grn',
  deleteGrn = '/product-service/purchasing-service/delete-purchasing',
  getGrnByID = '/product-service/grn-service/get-grn',
  latestGrn = '/backend/api/v1/product/grn/get-latest-product-grn-item',
  latestGrnList = '/backend/api/v1/product/grn/get-latest-product-grn-item-list',
  countGrn = '/notify/api/v1/purchasing/count-debt-payment-status',
  grnImroveList = '/backend/api/v1/product/grn/list',

  //config
  getConfig = '/product-service/config-service/get-config',
  saveConfig = '/product-service/config-service/save-config',

  //grn
  paymentList = '/product-service/payment-service/get-payment-list',
  createPayment = '/product-service/payment-service/create-payment',
  updatePayment = '/product-service/payment-service/update-payment',
  getPaymentByID = '/product-service/payment-service/get-payment',
  patialPayment = '/product-service/payment-service/create-installment-payment',
  createCreditNote = '/product-service/credit-note-service/create-credit-note',

  //stock
  stockList = '/backend/api/v1/product/stock/list',
  updateStock = '/backend/api/v1/product/manage-stock',
  getStockByID = '/product-service/supplier-service/get-supplier',
  stockReport = '/stock-report',
  grnHistory = '/product-service/purchasing-service/get-purchasing-history',
  productGrn = '/product-service/grn-service/get-product-grn-item',
  manageStockLogs = '/product-service/grn-service/get-manage-stock-logs',
  manageOnlineStock = '/product-service/grn-service/manage-online-offline-stock',
  productsGrn = '/product-service/grn-service/get-product-grn-items',
  stockMovementReport = '/backend/api/v1/report/stock-movement',

  //quotation
  quotationList = '/backend/api/v1/order/quotation/list',
  createQuotation = '/backend/api/v1/order/quotation',
  updateQuotation = '/backend/api/v1/order/quotation/:id',
  deleteQuotation = '/backend/api/v1/order/quotation/:id',
  getQuotationByID = '/backend/api/v1/order/quotation/:id',
  quotationCustomerList = '/backend/api/v1/order/customers',
  updateQuotationStatus = '/backend/api/v1/order/quotation/cancel/:id',
  updateGrnQuotation = '/backend/api/v1/order/quotation/update-grn/:id',
  getQuotationLogs = '/product-service/purchasing-service/get-purchasing-logs',
  countQuotation = '/backend/api/v1/order/quotation-count',

  //point
  redeemList = '/order-service/point-service/get-redeem-list',
  updateRedeemStatus = '/order-service/point-service/update-redeem-status',
  pointList = '/order-service/point-service/get-point-list',

  //tax
  taxList = '/backend/api/v1/order/tax-invoice-customers',
  createTax = '/backend/api/v1/order/tax-invoice-customer',
  createTaxSupplier = '/backend/api/v1/order/tax-invoice-suppiler',
  updateTax = '/backend/api/v1/order/tax-invoice-customer/status/:id',
  deleteTax = '/product-service/supplier-service/delete-supplier',
  getTaxByID = '/backend/api/v1/order/tax-invoice-customer/:id',
  getSupplierTaxByID = '/backend/api/v1/order/tax-invoice-suppiler/:id',
  getMerchantTax = '/backend/api/v1/order/tax-invoice-config',
  updateMerchantTax = '/backend/api/v1/order/tax-invoice-config',
  customerTaxList = '/backend/api/v1/order/tax-invoice-customers-list',

  //supplier-order
  supplierOrderList = '/backend/api/v1/order/sale-order/list',
  createSupplierOrder = '/backend/api/v1/order/quotation',
  updateSupplierOrder = '/backend/api/v1/order/quotation/:id',
  deleteSupplierOrder = '/backend/api/v1/order/quotation/:id',
  getSupplierOrderByID = '/backend/api/v1/order/sale-order/:id',
  updateSupplierOrderStatus = '/backend/api/v1/order/sale-order/:id',
  countSupplierOrder = '/backend/api/v1/order/sale-order-count-status',

  //supplier-invoice
  supplierInvoiceList = '/backend/api/v1/order/b2b-invoice/list',
  updateSupplierInvoice = '/backend/api/v1/order/b2b-invoices/:id',
  getSupplierInvoiceByID = '/backend/api/v1/order/b2b-invoices/:id',
  updateInvoicePayment = '/backend/api/v1/order/sale-order-partial',
  getPatialPaymentByID = '/backend/api/v1/order/sale-order-partial/:id',
  countInvoice = '/backend/api/v1/order/sale-order-count',

  //supplier-billing-note
  supplierBillList = '/backend/api/v1/order/billing-note/list',
  createSupplierBill = '/backend/api/v1/order/billing-note',
  getSupplierBillByID = '/backend/api/v1/order/billing-note/:id',
  deleteSupplierBill = '/backend/api/v1/order/billing-note/:id',

  //dashboard mini rmx
  rmxUploadFile = '/backend/api/v1/report/rmx/upload-csv',
  rmxGetMasterProduct = '/backend/api/v1/report/rmx/products',
  rmxGetManufacturDashboard = '/backend/api/v1/report/rmx/dashboard/list',
  rmxDashboardSummary = '/backend/api/v1/report/rmx/dashboard/summary',
  overallDashboard = '/backend/api/v1/report/rmx/dashboard/overall',

  //report
  reportOrderFull = '/backend/api/v1/report/order-full/export',
  reportMember = '/backend/api/v1/report/customer/export',
  reportOrderProductFull = '/backend/api/v1/report/order-product-full/export',
  reportPurchase = '/backend/api/v1/report/purchase/list',
  reportCustomerDebt = '/backend/api/v1/report/customer/debt',
  reportStock = '/backend/api/v1/report/product/profit',
  reportStockWithTax = '/backend/api/v1/report/product/tax-profit',

  //return-order
  createReturnOrder = '/backend/api/v1/order/return',
  returnList = '/backend/api/v1/order/return/return-list',
  deleteReturn = '/backend/api/v1/order/return-product/:id',
  getReturnByID = '/backend/api/v1/order/return/:id',
  updateReturnStatus = '/backend/api/v1/order/return/:id',
  returnReport = '/backend/api/v1/order/return/export',

  //manage-roles
  roleList = '/backend/api/v1/merchant/roles/list',
  createRole = '/backend/api/v1/merchant/roles/create',
  updateRole = '/backend/api/v1/merchant/roles/update/:id',
  getRoleByID = '/backend/api/v1/merchant/role/:id',
  deleteRole = '/backend/api/v1/merchant/roles/delete/:id',

  //manage-permission
  permissionList = '/backend/api/v1/merchant/permission/list',
  createPermission = '/backend/api/v1/merchant/permission/create',
  updatePermission = '/backend/api/v1/merchant/permission/update/:id',
  getPermissionByID = '/backend/api/v1/merchant/permission/:id',
  deletePermission = '/backend/api/v1/merchant/permission/delete/:id',

  //manage-role-permission
  rolePermissionList = '/backend/api/v1/merchant/role-permission/list',
  createRolePermission = '/backend/api/v1/merchant/role-permission/create',
  deleteRolePermission = '/backend/api/v1/merchant/role-permission/delete/:id',
  refreshPermission = '/internal/api/v1/merchant/permissions',

  //manage-role-package
  rolePackageList = '/backend/api/v1/merchant/package-role/list',
  createRolePackage = '/backend/api/v1/merchant/package-role/create',
  deleteRolePackage = '/backend/api/v1/merchant/package-role/delete/:id',
  updateRolePackage = '/backend/api/v1/merchant/package-role/update/:id',

  //manage-merchant-type
  createMerchantType = '/backend/api/v1/merchant/merchant-type/create',
  deleteMerchantType = '/backend/api/v1/merchant/merchant-type/delete/:id',
  getMerchantTypeList = '/backend/api/v1/merchant/merchant-type/:name',

  //content
  contentList = '/backend/api/v1/content/list',
  pagenameList = '/backend/api/v1/content/getpages',
  createContent = '/backend/api/v1/content/save',
  getContentByID = '/backend/api/v1/content/detail',
  deleteContent = '/backend/api/v1/content/:id',

  getAddress = '/geo-service/geo/find-address',

  //memberPoint
  memberPointList = '/order-service/point-service/get-point-list',
  updateConfigPoint = '/backend/api/v1/merchant/point-role/update',
  deleteConfigPoint = '/backend/api/v1/merchant/point-role/delete/:id',
  getDetailConfigPoint = '/backend/api/v1/merchant/point-role',
  getMemberList = '/backend/api/v1/order/member-lists',
  getMemberDetail = '/backend/api/v1/order/member/:id',
  updateMember = '/backend/api/v1/order/member/:id',
  getMemberPointInfo = '/backend/api/v1/order/member-point/:id',
  adjustMemberPoint = '/backend/api/v1/order/member-point/:id',
  getEarnPointHistory = '/backend/api/v1/order/member-earn-history',
  getBurnPointHistory = '/backend/api/v1/order/member-burn-history',
  getAllEarnPointHistory = '/backend/api/v1/order/member-earn-history-all',
  getALlBurnPointHistory = '/backend/api/v1/order/member-burn-history-all',

  //member-advertise
  rewardList = '/backend/api/v1/redeem/rewards-list',
  createReward = '/backend/api/v1/redeem/reward-create',
  updateReward = '/backend/api/v1/redeem/reward-update/:id',
  deleteReward = '/backend/api/v1/redeem/reward-delete/:id',
  getRewardByID = '/backend/api/v1/redeem/reward/:id',
  redeemReward = '/backend/api/v1/redeem/redeem-reward',

  //stock config
  updateConfigStock = '/backend/api/v1/product/minimum-stock/update',
  deleteConfigStock = '/backend/api/v1/product/minimum-stock/delete/:id',
  getDetailConfigStock = '/backend/api/v1/product/minimum-stock',
  countMinimumStock = '/backend/api/v1/product/stock/minimum-notice',
}
